import LicensePlateStars from "@components/Icons/Rca/LicensePlateStars";

const LicensePlate = ({ plateNumber }) => (
  <div className="flex h-10 w-[184px] items-center rounded-[4px] border-2 border-black">
    <div className="flex h-full w-6 flex-col items-center justify-center gap-[2px] bg-[#034EA2] px-1">
      <LicensePlateStars width={16} height={16} />
      <span className="text-[12px] font-medium leading-[12px] text-[#D9D9D9]">
        RO
      </span>
    </div>
    <div className="flex h-full flex-1 items-center justify-center bg-white px-2 text-center text-[24px] font-medium uppercase leading-[32px]">
      {plateNumber}
    </div>
  </div>
);

export default LicensePlate;
